export default __webpack_public_path__ + "static/media/receipt.6d538388.svg";